import { useAuth } from '../../../use';
import { odata } from '../../conf';
import Actions from '../../odata/actions';

const auth = useAuth();
const actions = new Actions('questionAlternative', 'questionAlternatives');

const customActions = {
  async LOAD_questionAlternatives({ rootGetters, commit }, questionId) {
    const token = await auth.getAccessToken();
    const data = await odata.o(rootGetters, token)
      .get('questionAlternatives')
      .query({
        $filter: `IsDeleted eq false AND questionId eq ${questionId}`,
        $orderby: 'created desc',
      });
    commit('SET_questionAlternatives', data);
    return data;
  },
};

export default { ...actions, ...customActions };
